import React from 'react';
import { Link } from 'react-router-dom';
import logoImg from '../../assets/logo.png';
import './PublicFooter.css';

export default function PublicFooter() {
  return (
    <footer className="public-site-footer">
      <div className="public-site-footer__grid">
        <div className="public-site-footer__brand">
          <Link to="/" className="public-site-footer__logo" aria-label="CivilFox home">
            <img src={logoImg} alt="" />
            <span>CivilFox</span>
          </Link>
          <p>Free UPSC preparation, built around how you study.</p>
        </div>

        <nav className="public-site-footer__links" aria-label="Company">
          <h2>Company</h2>
          <Link to="/about">About us</Link>
          <Link to="/contact">Contact us</Link>
          <Link to="/privacy">Privacy</Link>
        </nav>

        <nav className="public-site-footer__links" aria-label="Study resources">
          <h2>Study resources</h2>
          <Link to="/pyq-search">PYQ Search</Link>
          <Link to="/mock-test">Mock Test</Link>
          <Link to="/news">News</Link>
        </nav>

        <div className="public-site-footer__contact">
          <h2>Contact us</h2>
          <p>North Campus,<br />University of Delhi,<br />New Delhi</p>
          <Link to="/contact">Get in touch</Link>
        </div>
      </div>

      <div className="public-site-footer__bottom">
        <span>© {new Date().getFullYear()} CivilFox</span>
        <div>
          <Link to="/login">Login</Link>
          <Link to="/register">Start free</Link>
        </div>
      </div>
    </footer>
  );
}
